module.exports = __webpack_public_path__ + "img/BPPMP7.7ff5bc60.png";